import React from "react";
import { ABOUT_IMAGE, SHOP_INFO } from "../constants/shopData";
import { Lock, Handshake, Sparkles } from "lucide-react";

const POINTS = [
  {
    icon: Lock,
    title: "Appointment Only",
    body:
      "No walk-ins, no rush. Every visit is scheduled so you get our full attention and a private look at our inventory.",
  },
  {
    icon: Handshake,
    title: "Buy · Sell · Trade",
    body:
      "Fair offers on cards you bring in. Trade-ups, trade-downs, sell outright — we work with collectors and investors alike.",
  },
  {
    icon: Sparkles,
    title: "Curated For Collectors",
    body:
      "From vintage Base Set holos to modern alt-art chase cards — every piece in the case is hand-picked.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white border-b-4 border-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <span className="tag-chip" data-testid="about-eyebrow">
              /// About The Shop
            </span>
            <h2
              data-testid="about-heading"
              className="mt-6 font-heading uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] text-black"
            >
              A <span className="text-[#FF1F1F]">private</span> Pokémon shop in {SHOP_INFO.city}.
            </h2>
            <p className="mt-8 text-lg leading-relaxed text-black/80 max-w-2xl">
              {SHOP_INFO.appointmentNote} Whether you&apos;re hunting a graded
              Charizard, ripping the latest set, or finally moving that binder
              you&apos;ve held since &apos;99 — you get the table to yourself.
            </p>
            <p className="mt-4 text-base leading-relaxed text-black/70 max-w-2xl">
              Based in Springtown and serving collectors across{" "}
              <strong>Weatherford</strong>, <strong>Azle</strong>,{" "}
              <strong>Fort Worth</strong>, and the wider <strong>DFW Metroplex</strong>{" "}
              — a private Pokémon TCG shop without the foot-traffic noise.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
              {POINTS.map((p) => (
                <div
                  key={p.title}
                  data-testid={`about-point-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="nb-card p-5"
                >
                  <p.icon className="text-[#FF1F1F]" size={28} strokeWidth={2.5} />
                  <h3 className="font-heading uppercase text-2xl mt-3">{p.title}</h3>
                  <p className="mt-2 text-sm text-black/75 leading-relaxed">{p.body}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="nb-card overflow-hidden" data-testid="about-image-card">
              <div className="aspect-[4/5] w-full overflow-hidden border-b-4 border-black">
                <img
                  src={ABOUT_IMAGE}
                  alt="Rocket Card Shop interior"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-5 bg-[#0A0A0A] text-white">
                <div className="font-mono text-xs uppercase tracking-widest text-[#FF1F1F]">
                  The Vault
                </div>
                <div className="font-heading text-2xl uppercase mt-1">
                  Springtown, Texas
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
